export default __webpack_public_path__ + "static/media/unfill-warning.2c48bd77.svg";